import React from 'react';
import Highlights from '../Services/Highlights'
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../HeroSectionServices'
import Hero from '../HeroCont'
import HeroCorp from '../HeroCorp'
import Footer from '../../Footer/Footer';

function Products(){
    return (
        <div>
            <Hero/>
            <Highlights />
            <Footer/>
{/*            
            <HeroCorp/> */}
            
        </div>
    );
}

export default Products;
